import { navItems, sectionIds } from '../../data/navigation';
import { useNavToggle } from '../../hooks/useNavToggle';
import { useScrollSpy } from '../../hooks/useScrollSpy';
import { useScrolled } from '../../hooks/useScrolled';

export function Header() {
  const { isOpen, toggle, close, headerRef } = useNavToggle();
  const activeId = useScrollSpy(sectionIds);
  const isScrolled = useScrolled();

  const className = [
    'site-header',
    isOpen && 'nav-open',
    isScrolled && 'is-scrolled',
  ].filter(Boolean).join(' ');

  return (
    <header className={className} id="top" ref={headerRef}>
      <div className="wrap header-inner">
        <a
          className="brand"
          href="#top"
          aria-label="ADCS — Aerospace Design and Consulting Services, back to top"
        >
          <img
            className="brand-mark"
            src="/assets/logo.png"
            srcSet="/assets/logo.png 1x, /assets/logo@2x.png 2x"
            alt=""
            width={280}
            height={76}
            fetchPriority="high"
            decoding="async"
          />
        </a>

        <button
          className="nav-toggle"
          type="button"
          aria-expanded={isOpen}
          aria-controls="site-nav"
          onClick={toggle}
        >
          <span className="nav-toggle-bars" aria-hidden="true">
            <span />
            <span />
          </span>
          <span className="nav-toggle-label">Menu</span>
        </button>

        <nav className="site-nav" id="site-nav" aria-label="Primary">
          <ul className="nav-list">
            {navItems.map(({ label, href }) => (
              <li key={href}>
                <a
                  href={href}
                  onClick={close}
                  aria-current={activeId === href.slice(1) ? 'true' : undefined}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
          <a className="btn btn-ghost nav-cta" href="#contact" onClick={close}>
            Get in touch
          </a>
        </nav>
      </div>
    </header>
  );
}
